import React from "react";
import SectionHeading from "./sectionHeading";
import { ArrowRight } from "@speedoc/design-assets/build/icons/index.js";
import Link from "./link";
import { Remarkable } from "remarkable";
import { LazyLoadImage } from "react-lazy-load-image-component";

const markdown = new Remarkable();

const PersonaSection = ({ content }) => {
  const { title, subtitle, description, linkUrl, linkText, linkCaption, image } = content;

  return (
    <div id="personaSection">
      <div className="personaLeft">
        <SectionHeading title={title} subtitle={subtitle} />
        <div dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
        {linkCaption && <div className="caption">{linkCaption}</div>}
        {linkUrl && (
          <Link
            link={linkUrl}
            text={
              <>
                <span>{linkText}</span> <ArrowRight className="arrow right" />
              </>
            }
            className="buttonLink sm"
          />
        )}
      </div>
      <div className="personaRight">
        <LazyLoadImage src={image?.url} alt={image?.alternativeText || ""} effect="blur" />
      </div>
    </div>
  );
};

export default PersonaSection;
